// imports
import JsonApiCollection from '$dependencies/JsonApiCollection';
import MeasurementAdditionModel from '$models/measurement/MeasurementAdditionModel';
import Config from '$root/Config';

// class definition
export default class MeasurementAdditionCollection extends JsonApiCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || MeasurementAdditionModel;
		args.config = {
			url: Config.getUrl('measurementAddition'),
		};
		args.jsonApi = { order: { weight: 'asc' } };
		// call super constructor
		super(args);
	}
}
